<div class="modal-body p-0">
  <div class="release-notification-modal" [ngClass]="getSeverityClass(news?.severity)">
    <div class="notification-header p-3">
      <div class="d-flex align-items-center">
        <i class="fs-2 me-2" [ngClass]="getSeverityIcon(news?.severity)"></i>
        <div>
          <h4 class="mb-0">{{news?.title}}</h4>
          <small class="text-muted" *ngIf="news?.sentAt">{{news.sentAt | date:'medium'}}</small>
        </div>
      </div>
    </div>
    <div class="notification-content p-3">
      <h5 class="subject mb-2" *ngIf="news?.subject">{{news.subject}}</h5>
      <div class="body mb-3" *ngIf="news?.body">
        <p>{{news.body}}</p>
      </div>
      <div class="release-link mb-3" *ngIf="news?.latestReleaseUrl">
        <a [href]="news.latestReleaseUrl" target="_blank" class="btn btn-link p-0">
          <i class="ri-external-link-line me-1"></i>
          <span transloco="viewFullReleaseNotes">View Full Release Notes</span>
        </a>
      </div>
    </div>
    <div class="notification-footer p-3 border-top">
      <div class="row justify-content-center">
        <div class="col-4">
          <button class="btn btn-secondary w-100" transloco="gotIt" (click)="bsModalRef.hide()"></button>
        </div>
      </div>
    </div>
  </div>
</div>
